import { FC } from 'react'
import { ToolbarZoomIn } from './ToolbarZoomIn'
import { ToolbarZoomOut } from './ToolbarZoomOut'
import { ToolbarZoomReset } from './ToolbarZoomReset'
import { ToolbarDeselect } from './ToolbarDeselect'
import { ToolbarUndo } from './ToolbarUndo'
import { ToolbarRedo } from './ToolbarRedo'
import { ToolbarCrop } from './ToolbarCrop'
import { ToolbarRemove } from './ToolbarRemove'
import './Toolbar.scss'
import { ToolbarAutoplay } from './ToolbarAutoplay'
import { ToolbarNew } from './ToolbarNew'
import { ToolbarDownload } from './ToolbarDownload'
import { useSelectAllHotKey } from './hooks/useSelectAllHotKey'

export const Toolbar: FC = () => {
  useSelectAllHotKey()

  return (
    <div className="Toolbar">
      <ToolbarNew />

      <ToolbarDeselect />

      <ToolbarCrop />
      <ToolbarRemove />

      <ToolbarUndo />
      <ToolbarRedo />

      <ToolbarZoomIn />
      <ToolbarZoomOut />
      <ToolbarZoomReset />

      <ToolbarAutoplay />
      <ToolbarDownload />
    </div>
  )
}
